






























import Vue from "vue";
import { Header } from "../MyTable.vue";
import { axios } from "../../plugins";
import EditAutoScaling from "./EditAutoScaling.vue";
import ShowYaml from "./ShowYaml.vue";
import AppCard from "./AppCard.vue";
import { uuid } from "@/utils/uuid";

const TableHeaders: Header[] = [
  { title: "组件名", key: "", width: 220 },
  { title: "版本", key: "" },
  { title: "副本数", key: "" },
  { title: "CPU使用量", key: "" },
  { title: "状态", key: "" },
  { title: "创建人", key: "createBy" },
  { title: "创建时间", key: "createTime", width: 200 },
  { title: "操作", key: "", width: 80 }
];

export default Vue.extend({
  name: "TableList",
  components: { EditAutoScaling, ShowYaml, AppCard },
  props: {
    projectId: { type: String },
    type: { type: String, default: "Deployment" }
  },
  data() {
    return {
      uuid: uuid(),
      TableHeaders
    };
  },
  computed: {
    tableData() {
      return this.$store.getters[`PrjAppCom/${this.type}/tableData`];
    },
    pageNum() {
      return this.$store.state.PrjAppCom[this.type].pageNum;
    },
    hasNext() {
      return this.$store.state.PrjAppCom[this.type].hasNext;
    },
    total() {
      return this.$store.state.PrjAppCom[this.type].total;
    },
    loading() {
      return this.$store.state.PrjAppCom[this.type].loading;
    }
  },
  mounted() {
    this.getTable();
  },
  beforeDestroy() {
    this.$store.dispatch(`PrjAppCom/${this.type}/clear`);
  },
  methods: {
    handleCommand({ type, data }: { type: string; data: any }) {
      switch (type) {
        case "edit":
          this.$emit("create", data);
          break;
        case "replay":
          this.replay(data);
          break;
        case "delete":
          this.del(data.metadata.name);
          break;
        case "auto":
          this.getAutoScaling(data.metadata.name);
          break;
        case "yaml":
          this.getYaml(data.metadata.name);
      }
    },
    turnPage(page: number) {
      this.$store.dispatch(`PrjAppCom/${this.type}/pageTurn`, { page });
    },
    getTable() {
      this.$store.dispatch(`PrjAppCom/${this.type}/getData`, {
        url: `/${this.type.toLowerCase()}/${this.projectId}`,
        append: "&limit=20"
      });
    },
    getAutoScaling(name: string) {
      this.$store.commit(`PrjAppCom/${this.type}/SET_LOADING`, true);
      axios
        .get(`/autoscaling/${this.projectId}?loadType=${this.type}&app=${name}`)
        .then(res => {
          if (res.data.data) {
            (this.$refs.auto as any).show(res.data.data, true);
          } else {
            (this.$refs.auto as any).show(name, false);
          }
        })
        .finally(() => {
          this.$store.commit(`PrjAppCom/${this.type}/SET_LOADING`, false);
        });
    },
    replay(data: any) {
      this.$store.commit(`PrjAppCom/${this.type}/SET_LOADING`, true);
      axios
        .post(
          `/${this.type === "Deployment" ? "deployment" : "statefulset"}/${
            this.projectId
          }/${data.metadata.name}/restart`
        )
        .then(() => {
          this.$emit("showAppInfo", { ...data, __restart: true });
        })
        .finally(() => {
          this.$store.commit(`PrjAppCom/${this.type}/SET_LOADING`, false);
        });
    },
    getYaml(name: string) {
      this.$store.commit(`PrjAppCom/${this.type}/SET_LOADING`, true);
      axios
        .get(`${this.type.toLowerCase()}/${this.projectId}/${name}/yaml`)
        .then(res => {
          if (res.data.data) {
            (this.$refs.showYaml as any).show(res.data.data, name);
          }
        })
        .finally(() => {
          this.$store.commit(`PrjAppCom/${this.type}/SET_LOADING`, false);
        });
    },
    del(name: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.$store
          .dispatch(`PrjAppCom/${this.type}/delete`, {
            url: `/${this.type.toLowerCase()}/${this.projectId}/${name}`
          })
          .then(() => {
            this.$message.success("删除成功");
            this.getTable();
          });
      });
    }
  }
});
